import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authApiCall } from '../services/http';
import { endpoints } from '../config';
import { setAuthToken, setAuthUser } from '../redux/reducers/authSlice';
import { byProductLabel } from '../helpers/products';

// Carga el catálogo de productos (GET /user-api/products) y lo separa en planes y addons.
// `enabled` controla cuándo dispara (típicamente al abrir un diálogo) para no pedirlo de más.
// Solo se devuelven productos con status === 'active'. `bySlug` mapea slug -> producto para
// poder pintar el displayName a partir de un planSlug/addonSlug.
export default function useProducts(enabled = true) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.auth.authToken);

  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);
  const [bySlug, setBySlug] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);

    authApiCall({
      method: 'GET',
      endpoint: endpoints.products,
      path: '/',
      navigate,
      dispatch,
      setAuthUser,
      setAuthToken,
      authToken,
      redirectRoute: null,
    })
      .then((res) => {
        if (cancelled) return;
        const data = res?.data;
        const list = Array.isArray(data) ? data : data?.products || data?.items || [];
        const active = list.filter((p) => p.status === 'active');
        setPlans(active.filter((p) => p.type === 'plan').sort(byProductLabel));
        setAddons(active.filter((p) => p.type === 'addon').sort(byProductLabel));
        setBySlug(Object.fromEntries(list.map((p) => [p.slug, p])));
      })
      .catch((e) => {
        if (!cancelled) setError(e?.message || 'Error cargando productos');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, authToken]);

  return { plans, addons, bySlug, loading, error };
}
